export default __webpack_public_path__ + "static/shop-best-sellers-2c4bbfc299be886d9efd8e0f1e6549a7.webp";